import React from 'react';
import '../CSS/Sidebar.css';

// Default category icons mapping (using text symbols)
const categoryIcons = {
  'ai-recommendations': '✦',
  'appetizers': '◆',
  'entrees': '■',
  'drink': '●',
  'desserts': '◈',
  'pizza': '◐',
  'salads': '◇',
  'shareables': '◉',
  'subs&burgers': '▣',
  'smoothies': '◕',
  'healthy': '◈',
  // Mexican food categories
  'tacos': '◆',
  'burritos': '▪',
  'enchiladas': '◆',
  'quesadillas': '◇',
  'fajitas': '◉',
  'margaritas': '●',
  'bowls': '■'
};

function Sidebar({ activeCategory, onCategoryChange, fullMenu }) {
  // Helper function to format category labels
  const formatCategoryLabel = (categoryId) => {
    const labelMap = {
      'ai-recommendations': 'Smart Choice',
      'appetizers': 'Appetizers',
      'entrees': 'Entrees',
      'drink': 'Drinks',
      'desserts': 'Desserts',
      'pizza': 'Pizza',
      'salads': 'Salads',
      'shareables': 'Shareables',
      'subs&burgers': 'Subs & Burgers',
      'smoothies': 'Smoothies',
      'healthy': 'Healthy Options',
      // Mexican food categories
      'tacos': 'Tacos',
      'burritos': 'Burritos',
      'enchiladas': 'Enchiladas',
      'quesadillas': 'Quesadillas',
      'fajitas': 'Fajitas',
      'margaritas': 'Margaritas',
      'bowls': 'Bowls'
    };
    return labelMap[categoryId] || categoryId.charAt(0).toUpperCase() + categoryId.slice(1);
  };

  // Generate categories dynamically from menu data
  const categories = React.useMemo(() => {
    const cats = [{ id: 'ai-recommendations', label: 'Smart Choice', icon: '✦' }];
    
    if (fullMenu && fullMenu.length > 0) {
      // Get unique categories from menu items
      const menuCategories = [...new Set(fullMenu.map(item => item.category))];
      
      menuCategories.forEach(categoryId => {
        cats.push({
          id: categoryId,
          label: formatCategoryLabel(categoryId),
          icon: categoryIcons[categoryId] || '🍽️' // Default icon if not mapped
        });
      });
    }
    
    return cats;
  }, [fullMenu]);

  return (
    <div className="sidebar">
      {categories.map((category, index) => (
        <React.Fragment key={category.id}>
          <button
            className={`category-btn ${
              activeCategory === category.id ? 'active' : ''
            } ${category.id === 'ai-recommendations' ? 'ai-special' : ''}`}
            onClick={() => onCategoryChange(category.id)}
          >
            {category.id === 'ai-recommendations' && (
              <span className="ai-badge">AI POWERED</span>
            )}
            <span className="category-label">{category.label}</span>
          </button>
          {index === 0 && categories.length > 1 && (
            <div className="sidebar-divider">
              <span className="divider-text">Menu Categories</span>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}

export default Sidebar; 